import React from 'react';

const Regulations = () => {
  return (
    <div className="container my-4">
      <h1 className="text-center mb-4">Regulamin portalu Checkardi</h1>

      <section className="mb-4">
        <h2 className="h5">1. Wprowadzenie</h2>
        <p>
          Poniższy Regulamin określa zasady funkcjonowania portalu internetowego checkardi.azurewebsites.net,
          prawa i obowiązki użytkowników, administratora i moderatorów oraz zakres odpowiedzialności.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="h5">2. Definicje</h2>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">portal – strona www i inne narzędzia internetowe udostępniane przez administratora.</li>
          <li className="list-group-item">administrator – właściciel portalu.</li>
          <li className="list-group-item">moderator – osoba kontrolująca prawidłowe funkcjonowanie portalu.</li>
          <li className="list-group-item">użytkownik – osoba posiadająca konto lub korzystająca z funkcjonalności portalu.</li>
          <li className="list-group-item">konto – miejsce w portalu, w którym użytkownik może wprowadzać dane i zamieszczać zdjęcia.</li>
          <li className="list-group-item">produkt – artykuł przeznaczony do stosowania na ciało w celu oczyszczenia lub upiększenia.</li>
          <li className="list-group-item">recenzja – osobista opinia na temat produktu.</li>
          <li className="list-group-item">blokada – czasowe lub trwałe ograniczenie dostępu użytkownika naruszającego regulamin.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2 className="h5">3. Prawa użytkownika</h2>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">Zmiana lub usunięcie danych poprzez kontakt mailowy.</li>
          <li className="list-group-item">Dodawanie recenzji i zdjęć produktów.</li>
          <li className="list-group-item">Korzystanie z portalu zgodnie z jego przeznaczeniem.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2 className="h5">4. Obowiązki użytkownika</h2>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">Posiadanie praw do materiałów publikowanych w portalu.</li>
          <li className="list-group-item">Powstrzymywanie się od działań zakłócających portal lub naruszających prawo.</li>
          <li className="list-group-item">Przestrzeganie praw autorskich i zasad uczciwej konkurencji.</li>
          <li className="list-group-item">Odpowiedzialność za treści dodawane w portalu.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2 className="h5">5. Konto i rejestracja</h2>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">Podawanie prawdziwych danych.</li>
          <li className="list-group-item">Zgoda na przetwarzanie danych zgodnie z regulaminem i ustawą o ochronie danych.</li>
          <li className="list-group-item">Możliwość blokady konta w przypadku naruszenia regulaminu.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2 className="h5">6. Fotografie i recenzje</h2>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">Prawa autorskie użytkownika do publikowanych zdjęć.</li>
          <li className="list-group-item">Odpowiedzialność za treść i zgodność z regulaminem.</li>
          <li className="list-group-item">Zasady dodawania ocen produktów i moderacji treści.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2 className="h5">7. Bazy danych i prawa administratora</h2>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">Ochrona bazy danych i ograniczenia jej użycia.</li>
          <li className="list-group-item">Zakaz automatycznego kopiowania danych.</li>
          <li className="list-group-item">Administrator może żądać naprawienia skutków naruszeń.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2 className="h5">8. Zmiany regulaminu</h2>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">Administrator może zmieniać regulamin, informując użytkowników o zmianach.</li>
          <li className="list-group-item">Brak akceptacji zmian skutkuje możliwością likwidacji konta.</li>
        </ul>
      </section>
    </div>
  );
};

export default Regulations;
